import React, {Component} from 'react';

import {
    Row
} from 'reactstrap';

import BasicsForm from "./forms/BasicsForm";

class GeneralFrame extends Component {
    render() {
        return (
            <div>
                <Row>
                    <h3>Let's Start with the Basics</h3>
                </Row>
                <hr/>
                <p>Hi there! This and the next few pages make up your PolyRents digital housing application.</p>
                <p>Landlords use the information you provide as part of their process of picking which tenants to rent to. Make sure to fill each page with as much detail as you can. You can come back
                    and add information at any time.</p>
                <p>If you have any questions, feel free to hit us up at any time via the blue messaging button in the bottom right of your screen.</p>
                <hr/>
                <BasicsForm/>
            </div>
        )
            ;
    }
}

export default GeneralFrame;



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/BasicsFrame.js